module.exports = __webpack_public_path__ + "img/Vector 8.581c142d.png";